import React from 'react';
import './WhatWeDeliver.css';

const renderDeliverableIcon = (type) => {
  switch (type) {
    case "hospital":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      );
    case "blueprint":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="9" y1="21" x2="9" y2="9" />
        </svg>
      );
    case "staffing":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "university":
    case "protection":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
    case "readiness":
    case "compliance":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      );
    case "audit":
    default:
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
        </svg>
      );
  }
};

const WhatWeDeliver = ({
  badge = "What We Deliver",
  heading,
  subtitle,
  deliverables = []
}) => {
  if (!heading && (!deliverables || deliverables.length === 0)) return null;

  return (
    <section className="what-we-deliver-section">
      <div className="what-we-deliver-container">
        
        {/* --- 1. CENTERED TOP HEADER WITH DASHES --- */}
        <div className="what-we-deliver-header">
          {badge && (
            <div className="what-we-deliver-eyebrow">
              <span className="what-we-deliver-eyebrow-dash"></span>
              <span>{badge}</span>
              <span className="what-we-deliver-eyebrow-dash"></span>
            </div>
          )}
          
          {heading && (
            <h2 className="what-we-deliver-title">
              {heading}
            </h2>
          )}
          
          {subtitle && (
            <p className="what-we-deliver-subtitle">
              {subtitle}
            </p>
          )}
        </div>

        {/* --- 2. DISTINCT DELIVERABLE MODULES GRID (3 COLUMNS) --- */}
        {deliverables && deliverables.length > 0 && (
          <div className="what-we-deliver-grid">
            {deliverables.map((item, index) => {
              const formattedNum = item.id || String(index + 1).padStart(2, '0');

              return (
                <div key={index} className="what-we-deliver-module">
                  
                  {/* Top Meta Strip: Deliverable Index & Scope Tag */}
                  <div className="what-we-deliver-module-top">
                    <div className="what-we-deliver-phase-badge">
                      <span className="what-we-deliver-phase-dot"></span>
                      <span>Deliverable {formattedNum}</span>
                    </div>
                    {item.tag ? (
                      <span className="what-we-deliver-scope-tag">{item.tag}</span>
                    ) : (
                      <span className="what-we-deliver-scope-tag">Verified Scope</span>
                    )}
                  </div>

                  {/* Inline Icon + Title Unit */}
                  <div className="what-we-deliver-title-row">
                    <div className="what-we-deliver-icon-frame">
                      {item.icon || renderDeliverableIcon(item.iconType)}
                    </div>
                    <h3 className="what-we-deliver-module-title">
                      {item.title}
                    </h3>
                  </div>

                  {/* Body Description */}
                  <p className="what-we-deliver-module-desc">
                    {item.description}
                  </p>

                  {/* Distinctive Footer: Verified Output Indicator */}
                  <div className="what-we-deliver-module-footer">
                    <div className="what-we-deliver-check-indicator">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <span>Institutional Handover Asset</span>
                    </div>
                  </div>

                </div>
              );
            })}
          </div>
        )}

      </div>
    </section>
  );
};

export default WhatWeDeliver;